"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidTimestamp = void 0;
const date_fns_1 = require("date-fns");
// https://stackoverflow.com/questions/3143070/regex-to-match-an-iso-8601-datetime-string
const ISO_REGEX = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/;
function isValidTimestamp(timestamp) {
    return (0, date_fns_1.isValid)(new Date(timestamp)) && ISO_REGEX.test(timestamp);
}
exports.isValidTimestamp = isValidTimestamp;
